import { FormRow, FormSection } from 'framework/ui/layout';
import { DocumentScanUploaderInput } from 'domain/shared/employee';
import { FC } from 'react';
import { TextInput } from 'framework/form';
import { EMPLOYEE_TYPES_ALIAS } from 'domain/shared/employee';

const RequisitesSection: FC = () => {
  return (
    <FormSection title="Requisites" isVisible={employee => employee.employeeType === EMPLOYEE_TYPES_ALIAS.CONTRACTOR}>
      <FormRow>
        <TextInput source="extendedInformation.requisitesInformation.requisites" label="Requisites" />
      </FormRow>
      <DocumentScanUploaderInput source="extendedInformation.requisitesInformation.scansIds" label="Document scans" />
    </FormSection>
  );
};

export { RequisitesSection };
